// PRICING API attributes
export const PRICING_URL = '/product-information/rental/inventory/pricing';
export const STORE_SERVICES_URL = '/StoreSearchServices/v2/storesearch';
export const SEARCH_DISTANCE = 100;
export const STORES_LIMIT = 5;

export const TOOL_PRICE_OPTIONS = {
  fourHourRate: ['4-Hours'],
  dailyRate: ['Per Day'],
  weeklyRate: ['Per Week', '3 Days FREE'],
  monthlyRate: ['4 Weeks', '12 Days FREE']
};

export const VEHICLE_PRICE_OPTIONS = {
  seventyFiveMinutesRate: ['75-Minutes'],
  dailyRate: ['Per Day'],
  weeklyRate: ['Per Week']
};

// ItemIds to test use cases
export const TOOL_ITEMID = '309404470';
export const VEHICLE_ITEMID = '312555052';

// Vehicle categories
export const VEHICLE_CATEGORIES = ['45', '65', '95'];